<template>
    <div >
        <aside class="search-btn">
			<vButtonGroup class="tablelist-tabs clearfix" compact>
				<vButton
					size="large"
					v-for="(item,index) in btnsearch"
					:key="index"
					:theme="formData.itemstatus===item.value?'primary':'default'"
					@click="handleBtn(item.value)"
				>{{item.label}}</vButton>
			</vButtonGroup>
		</aside>
        <div class="width-70per" style="margin:auto">
            <div class="font-14 font-bold">{{formData.itemstatus == 0 ? '输入缺货订单号，发送给万邑通系统' : '输入需要恢复订单号，发送给万邑通系统'}}</div>
            <vTextarea class="margin-top-10" v-model="newsDetail" placeholder="支持输入多个订单号，一行一个" :rows="12"></vTextarea>
            <div class="margin-top-10 text-right">
                <vButton theme="primary" @click="submit">确定</vButton>
                <vButton class="margin-left-10" @click="cancel">重置</vButton>
            </div>
        </div>
    </div>
</template>

<script>
import { HttpGetWYTOrderNews } from "@/service/allotment";
export default {
    data(){
        return {
            btnsearch: [{
				value: 0,
				label: '订单缺货通知'
			}, {
				value: 1,
				label: '订单恢复通知'
			},],
            formData: {
				itemstatus: 0,
                chosetype:0,
			},
            newsDetail:'',
        }
    },
    methods:{
        handleBtn(value){
            this.formData.itemstatus = value;
            this.newsDetail = '';
        },
        submit(){
            let ordernos=this.newsDetail.replace(/\n/g,",");
            HttpGetWYTOrderNews({
                orderNos:ordernos,
                opType:this.formData.itemstatus==0?0:1
            }).then(res=>{
                this.$VMessage.success(res.message);
            },err=>{
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
        },
        cancel(){
            this.newsDetail = ''
        }
    }
}
</script>